__turbopack_context__.v({
  "volumeIcons": "eup9Bq_volumeIcons",
  "volumeSlider": "eup9Bq_volumeSlider",
  "volumeSliderContainer": "eup9Bq_volumeSliderContainer",
  "volumeSliderContainerOpen": "eup9Bq_volumeSliderContainerOpen",
});
